import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { isoWeek, isoYear } from '@core/utils';

export interface GenerateChecklistFormDialogResult {
    isoWeek: number | null;
    isoYear: number | null;
}

// Both fields must be blank (meaning "all weeks") or both set — a
// half-supplied pair is rejected server-side too (required_with on both
// rules), but catching it here gives the user an inline error instead of a
// round-trip.
function weekYearPairValidator(group: FormGroup): ValidationErrors | null {
    const week = group.get('isoWeek').value;
    const year = group.get('isoYear').value;

    return (week === null || week === '') === (year === null || year === '')
        ? null
        : { weekYearPair: true };
}

@Component({
    selector: 'pv-generate-checklist-form-dialog',
    templateUrl: 'generate-checklist-form.dialog.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GenerateChecklistFormDialog implements OnInit {

    formGroup = new FormGroup({
        isoWeek: new FormControl(null, [Validators.min(1), Validators.max(53)]),
        isoYear: new FormControl(null, [Validators.min(2000), Validators.max(2100)]),
    }, [weekYearPairValidator]);

    constructor(
        private _dialog: MatDialogRef<GenerateChecklistFormDialog>,
    ) { }

    ngOnInit() {
        const now = new Date();

        this.formGroup.setValue({
            isoWeek: isoWeek(now),
            isoYear: isoYear(now),
        });
    }

    clearWeek() {
        this.formGroup.setValue({
            isoWeek: null,
            isoYear: null,
        });
    }

    submit() {
        this.formGroup.updateValueAndValidity();
        if (!this.formGroup.valid) return;

        const result: GenerateChecklistFormDialogResult = this.formGroup.value;
        this._dialog.close(result);
    }

    cancel() {
        this._dialog.close();
    }
}
